import messages from './cmsBanner.json' with { type: 'json' };

export const cmsBannerFi: Readonly<typeof messages> = messages;
